import { Box, Flex, Text } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import type { ReactNode } from 'react';

const CARD_BUTTON_BG = '#FFFFFF';
const CARD_BUTTON_ICON_BG = '#D1D1D6';

export interface PosterCard {
  label: string;
  subtitle: string;
  onClick?: () => void;
  href?: string;
  icon?: ReactNode;
  chevron?: boolean;
  center?: boolean;
  hideIcon?: boolean;
  animation?: string;
}

export const PosterActionCard = ({
  label,
  subtitle,
  onClick,
  href,
  icon,
  chevron,
  center,
  hideIcon,
  animation,
}: PosterCard) => {
  const interactive = Boolean(onClick || href);

  let linkProps = {};
  if (href) {
    linkProps = {
      as: 'a' as const,
      href,
      target: '_blank',
      rel: 'noopener noreferrer',
    };
  } else if (onClick) {
    linkProps = { as: 'button' as const };
  }

  const defaultIcon = (
    <Box w="14px" h="14px" borderRadius="full" bg={CARD_BUTTON_ICON_BG} />
  );

  const textBlock = (
    <Box>
      <Text
        fontSize="10px"
        fontWeight="600"
        color="gray.900"
        lineHeight="1.2"
        letterSpacing="-0.2px"
      >
        {label}
      </Text>
      <Text
        fontSize="9px"
        color="gray.500"
        lineHeight="1.2"
        letterSpacing="-0.2px"
        noOfLines={1}
      >
        {subtitle}
      </Text>
    </Box>
  );

  return (
    <Flex
      {...linkProps}
      onClick={onClick}
      animation={animation}
      direction="column"
      justify={center ? 'flex-start' : 'space-between'}
      align={center ? 'flex-start' : 'stretch'}
      textAlign="left"
      bg={CARD_BUTTON_BG}
      borderRadius="14px"
      px="10px"
      py="8px"
      h="100%"
      w="100%"
      flex={1}
      cursor={interactive ? 'pointer' : 'default'}
      transition="transform 0.15s ease"
      _hover={interactive ? { transform: 'scale(1.02)' } : undefined}
      _active={interactive ? { transform: 'scale(0.98)' } : undefined}
    >
      {!hideIcon &&
        (center ? (
          (icon ?? defaultIcon)
        ) : (
          <Flex justify="space-between" align="center" w="100%" minH="14px">
            {icon ?? (chevron ? <Box /> : defaultIcon)}
            {chevron && <ChevronRightIcon color="gray.400" boxSize="14px" />}
          </Flex>
        ))}
      {center ? (
        <Flex flex={1} w="100%" align="center" gap={2}>
          <Flex flex={1} minW={0} direction="column" justify="center">
            {textBlock}
          </Flex>
          {hideIcon && chevron && (
            <ChevronRightIcon color="gray.400" boxSize="14px" flexShrink={0} />
          )}
        </Flex>
      ) : (
        textBlock
      )}
    </Flex>
  );
};
